import { ApplicationConfig, provideExperimentalZonelessChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { appRouting } from './app/app.routing';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { RouteReuseStrategy } from '@angular/router';
import { CustomReuseStrategy } from './shared/tools/utils/resue-strategy';
export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideAnimations(),
    ...appRouting,
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2000 } },
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
  ],
};
